import styled from 'styled-components'
import { Box, Typography } from 'src/components'

export const OverMap = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
`

export const Icon = styled.img`
    width: 90px;
    height: 90px;
    object-fit: contain;
`

export const TitleTypography = styled(Typography)`
    font-family: Poppins, sans-serif;
    line-height: 31px;
    letter-spacing: 0;
    padding-top: 16px;
    text-align: center;
`

export const ContentTypography = styled(Typography)`
    font-family: Poppins, sans-serif;
    line-height: 23px;
    letter-spacing: 0;
    text-align: center;
    padding-top: 13px;
`
